import React, { useCallback } from 'react';
import Option from '../../Option';
import ChatRenderText from '../Text';

interface ChatRenderVisitorRoleProps {
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    id: string;
    metadata?: {
      roles: {
        uid: string;
        displayName: string;
      }[];
    };
  };
  onRunNextStep?: (_: {
    uid: string;
    displayName: string;
    question: string;
  }) => void;
}

const ChatRenderVisitorRole = function ({
  message,
  onRunNextStep = () => {},
}: ChatRenderVisitorRoleProps) {
  const roles = message.metadata?.roles || [];

  const handleRoleSelection = useCallback(
    (id: string, label: string) => {
      onRunNextStep({
        uid: id,
        displayName: label,
        question: message.i18n,
      });
    },
    [onRunNextStep, message.i18n],
  );

  return (
    <ChatRenderText key={message.id} message={message} tooltip={false}>
      {roles.length > 0 ? (
        <div className="message-options">
          <ul className="message-options-list">
            {roles.map((role) => (
              <Option
                key={role.uid}
                id={role.uid}
                name={role.displayName}
                onClick={handleRoleSelection}
              />
            ))}
          </ul>
        </div>
      ) : null}
    </ChatRenderText>
  );
};

export default ChatRenderVisitorRole;
